<template>
  <section id="process-section" class="section">
    <section-content-wrapper paddingSm>
      <section-title :text="'Co zyskasz wybierając finansowanie od brutto.pl?'" id="process-card-list-heading" />
      <ul class="process-card-list" aria-labelledby="process-card-list-heading">
        <li class="process-card-list-item">
          <img class="card-icon" src="@/assets/images/icons/user-icon.svg" alt="" aria-hidden="true">
          <h3 class="list-item-heading">Elastyczne finansowanie</h3>
          <p class="list-item-text">Środki możesz przeznaczyć na każdy cel związany z firmą - od podatków i wynagrodzeń, po zakup towaru czy rozwój nowych działań.</p>
        </li>
        <li class="process-card-list-item">
          <img class="card-icon" src="@/assets/images/icons/edit-icon.svg" alt="" aria-hidden="true">
          <h3 class="list-item-heading">Szybki proces online</h3>
          <p class="list-item-text">Całość odbywa się w 100% zdalnie, a decyzja opiera się na wynikach sprzedażowych weryfikowanych w systemie Autopay (PayAutopay).</p>
        </li>
        <li class="process-card-list-item">
          <img class="card-icon" src="@/assets/images/icons/clock-icon.svg" alt="" aria-hidden="true">
          <h3 class="list-item-heading">Błyskawiczna wypłata</h3>
          <p class="list-item-text">Po podpisaniu umowy kodem SMS przelew trafia od razu na Twój rachunek - pieniądze są dostępne praktycznie natychmiast.</p>
        </li>
        <li class="process-card-list-item">
          <img class="card-icon" src="@/assets/images/icons/calendar-icon.svg" alt="" aria-hidden="true">
          <h3 class="list-item-heading">Wygodna i bezpieczna spłata</h3>
          <p class="list-item-text">Na poczet spłaty finansowania pobierany jest stały procent od sprzedaży, aż do momentu osiągnięcia pełnej kwoty</p>
        </li>
      </ul>
    </section-content-wrapper>
    <section-content-wrapper useBgColor>
      <div class="process-section-wrapper">
        <div class="process-section-column">
          <section-sub-title :text="'Proces finansowania'" class="process-sub-heading" id="process-list-heading"/>
          <ol class="process-oredered-list" aria-labelledby="process-list-heading">
            <li class="process-oredered-list-item">
              <h4 class="list-item-heading">Analiza</h4>
              <p class="list-item-text">Podłącz brutto.pl do Autopay i od razu poznaj, jaką kwotę finansowania możesz uzyskać.</p>
            </li>
            <li class="process-oredered-list-item">
              <h4 class="list-item-heading">Wybór oferty</h4>
              <p class="list-item-text">Sam decydujesz ile środków potrzebujesz, a umowę potwierdzasz online w kilka klików.</p>
            </li>
            <li class="process-oredered-list-item">
              <h4 class="list-item-heading">Wypłata środków</h4>
              <p class="list-item-text">Podpisujesz umowę i pieniądze ekspresowo trafiają na Twój rachunek.</p>
            </li>
            <li class="process-oredered-list-item">
              <h4 class="list-item-heading">Spłata</h4>
              <p class="list-item-text">Spłacasz procent od sprzedaży, elastycznie i bez obciążenia budżetu.</p>
            </li>
          </ol>
        </div>
        <img class="process-img" src="@/assets/images/finansowanie-img.png" alt="Aplikacja finansowania z 4 krokami procesu" aria-hidden="true">
      </div>
    </section-content-wrapper>
  </section>
</template>

<script>
import SectionTitle from '../common/SectionTitle'
import SectionSubTitle from '../common/SectionSubTitle'
import SectionContentWrapper from '../common/SectionContentWrapper.vue'

export default {
  name: 'InfosProcessSection',
  components: {
    SectionTitle,
    SectionSubTitle,
    SectionContentWrapper
  }
}
</script>
